import { Layout } from '@/components/forms/fields/types';
import { accountFields } from './accounts.fields';

const { name, note, activated } = accountFields;

// Main form layout - only editable fields
export const accountDetailLayout = {
  '': {
    activated,
    name,
    note,
  },
} satisfies Layout;
